import { PropsWithChildren, useMemo } from 'react';
import { ThemeProvider, useTheme } from '@material-ui/core/styles';
import { bayerGradient } from './bayerTheme';

/**
 * Forces the page-header banner to the Bayer wave gradient regardless of the
 * page's themeId.
 *
 * Backstage's `<Page>` sets `theme.page = getPageTheme({ themeId })`, and both
 * entity headers (themeId = entity `spec.type`) and scaffolder template cards
 * resolve their banner through that same shared map. Overriding `getPageTheme`
 * only around entity / techdocs-reader pages gives those headers the gradient
 * while `/create` template cards keep the solid-blue card theme.
 */
export const BayerGradientHeader = ({ children }: PropsWithChildren<{}>) => {
  const theme = useTheme();
  const gradientTheme = useMemo(
    () => ({ ...theme, getPageTheme: () => bayerGradient }),
    [theme],
  );
  return <ThemeProvider theme={gradientTheme}>{children}</ThemeProvider>;
};
